module.exports = __webpack_public_path__ + "img/13_7.48090489.png";